import type { Mission } from '../missions.ts'

export const cdc: Mission = {
  id: "cdc",
  name: "Centers for Disease Control and Prevention",
  short: "CDC",
  call: "Prevention",
  kind: "subagency",
  parent: "hhs",
  url: "https://www.cdc.gov/",
  established: 1946,
  palette: {
    primary: "#005eaa",
    secondary: "#112f4e",
    accent: "#0081a1",
  },
  colorSource: {
    kind: "site",
    url: "https://www.cdc.gov/",
  },
  motif: "shield",
  mission: {
    text: "CDC is committed to strengthening our public health system and restoring it to its core mission of protecting Americans from infectious and communicable diseases and investing in innovation to prevent, detect, and respond to such public health threats.",
    url: "https://www.cdc.gov/about/cdc/index.html",
  },
  fact: {
    text: "CDC opened on July 1, 1946, in Atlanta as the Communicable Disease Center, charged with keeping malaria from spreading.",
    url: "https://www.cdc.gov/museum/history/our-story.html",
  },
  logo: {
    file: "public/logos/cdc.svg",
    source: "https://commons.wikimedia.org/wiki/File:CDC_logo_2024.svg",
  },
  identifier: {
    about: "https://www.cdc.gov/about/index.html",
    accessibility: "https://www.cdc.gov/other/accessibility.html",
    foia: "https://www.cdc.gov/foia/",
    noFear: "https://www.cdc.gov/oeeowe/no-fear-act/",
    oig: "https://oig.hhs.gov/",
    performance: "https://www.cdc.gov/budget/index.html",
    privacy: "https://www.cdc.gov/other/privacy.html",
  },
  media: {
    photos: [
      {
        file: "/media/cdc-headquarters.jpg",
        small: "/media/cdc-headquarters-sm.jpg",
        alt: "Glass towers of CDC's Roybal campus in Atlanta behind trees and a CDC entrance sign.",
        title: "CDC Roybal campus, Atlanta",
        creator: "James Gathany, Centers for Disease Control and Prevention",
        source: "https://commons.wikimedia.org/wiki/File:CDC_Headquarters_PHIL_10693.tif",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/cdc-harkin-center.jpg",
        small: "/media/cdc-harkin-center-sm.jpg",
        alt: "The curving glass Tom Harkin Global Communications Center on CDC's Roybal campus, with a CDC sign in the foreground.",
        title: "Tom Harkin Global Communications Center, CDC Roybal campus",
        creator: "James Gathany, Centers for Disease Control and Prevention",
        source: "https://commons.wikimedia.org/wiki/File:Tom_Harkin_Global_Communications_Center_PHIL_8876.tif",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
